import axios from "@/util/basehttp";
import qs from "qs";

const pre = "/course/note";

const courseNote = {
  courseNoteList(courseId) {
    return axios.get(pre + `/courseNoteList`, {
      params: {
        courseId: courseId
      }
    });
  },
  courseUpdate(params) {
    return axios.post(pre + `/courseUpdate`, qs.stringify(params));
  },
  deleteCourseNote(id) {
    return axios.post(pre + `/courseDelete`, qs.stringify({ id: id }));
  }
};
export default courseNote;



// WEBPACK FOOTER //
// ./src/api/course/courseNote.js